export default "__VITE_ASSET__Y5$eDk3G__"